import React from 'react';
import { ChevronsDown } from 'react-feather';
import styles from './UserList.module.css';

/**
 * USER LIST COMPONENT
 * Displays global list of all users with status indicators
 * Story 7: AC7.1 - AC7.8
 */
function UserList({ users, currentUser, onUserClick }) {
  // SORT users by status (online -> afk -> offline) then alphabetically
  const sortedUsers = [...users].sort((a, b) => {
    // STATUS priority: online (0) -> away (1) -> offline (2)
    const statusOrder = { online: 0, away: 1, offline: 2 };
    const statusA = statusOrder[a.status] || 0;
    const statusB = statusOrder[b.status] || 0;

    if (statusA !== statusB) {
      return statusA - statusB;
    }

    // ALPHABETICAL within same status
    return a.handle.toLowerCase().localeCompare(b.handle.toLowerCase());
  });

  // COUNT by status
  const onlineCount = users.filter(u => u.status === 'online').length;
  const afkCount = users.filter(u => u.status === 'away').length;
  const offlineCount = users.filter(u => u.status === 'offline').length;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Benutzer ({users.length})</h3>
        <div className={styles.counts}>
          <span className={styles.onlineCount}>Online: {onlineCount}</span>
          {afkCount > 0 && (
            <span className={styles.afkCount}>AFK: {afkCount}</span>
          )}
          {offlineCount > 0 && (
            <span className={styles.offlineCount}>Offline: {offlineCount}</span>
          )}
        </div>
      </div>

      <div className={styles.userList}>
        {sortedUsers.map((user) => (
          <div
            key={user.userId || user.handle}
            className={`${styles.user} ${
              user.status === 'away' ? styles.away :
              user.status === 'offline' ? styles.offline : ''
            } ${user.handle === currentUser?.handle ? styles.currentUser : ''}`}
            onClick={() => onUserClick && onUserClick(user)}
            title={`Klicken für Whisper an ${user.handle}`}
          >
            {user.status === 'away' && <span className={styles.prefix}>[AFK]</span>}
            <span className={styles.handle}>
              {user.status === 'offline' ? `_${user.handle}_` : user.handle}
            </span>
            {user.isAdmin && (
              <ChevronsDown className={styles.adminBadge} size={14} title="Admin" />
            )}
          </div>
        ))}

        {users.length === 0 && (
          <div className={styles.empty}>Keine Benutzer online</div>
        )}
      </div>
    </div>
  );
}

export default UserList;
